/**
 * Conditional Search & Discovery facets (Dawn).
 *
 * Hide **Bottom Length** (`filter.p.m.custom.bottom_length`) unless Category
 * (`filter.p.t.category`) has an active pants/trousers, skirt, or dress value.
 *
 * Works with Dawn's AJAX facet reloads (#ProductGridContainer).
 */
(function () {
  'use strict';

  if (window.__kailaConditionalFacetsInit) return;
  window.__kailaConditionalFacetsInit = true;

  var CATEGORY_PARAM = 'filter.p.t.category';
  var BOTTOM_LENGTH_PARAM = 'filter.p.m.custom.bottom_length';
  var HIDDEN_CLASS = 'ayami-facet-hidden';

  /** Labels that unlock Bottom Length (EN + common variants). */
  var ALLOW_LABEL_RE =
    /\b(dress|dresses|skirt|skirts|pant|pants|trouser|trousers|legging|leggings)\b/i;
  /** Explicitly exclude underwear even if it contains "pant". */
  var DENY_LABEL_RE = /\b(underpant|underpants|underwear|pantie|panties|brief|briefs)\b/i;

  function ensureStyle() {
    if (document.getElementById('ayami-conditional-facets-style')) return;
    var style = document.createElement('style');
    style.id = 'ayami-conditional-facets-style';
    style.textContent =
      '.' +
      HIDDEN_CLASS +
      '{display:none!important;visibility:hidden!important;}' +
      '.' +
      HIDDEN_CLASS +
      '[open]{display:none!important;}';
    document.head.appendChild(style);
  }

  function normalizeLabel(text) {
    return String(text || '')
      .replace(/\(\s*\d+\s*products?\s*\)/gi, ' ')
      .replace(/\(\s*\d+\s*\)/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function labelAllowsBottomLength(label) {
    var t = normalizeLabel(label);
    if (!t) return false;
    if (DENY_LABEL_RE.test(t)) return false;
    return ALLOW_LABEL_RE.test(t);
  }

  function filterDetailsByParam(param) {
    var needle = String(param || '').toLowerCase();
    if (!needle) return [];
    var out = [];
    var seen = new Set();
    Array.prototype.slice
      .call(document.querySelectorAll('details.js-filter, .js-filter, details.facets__disclosure, details.mobile-facets__details'))
      .forEach(function (el) {
        if (seen.has(el)) return;
        var id = (el.id || '').toLowerCase();
        var summary = ((el.querySelector('summary') || {}).textContent || '').toLowerCase();
        var hasInput = !!el.querySelector('input[name="' + param + '"]');
        var match =
          id.indexOf(needle) !== -1 ||
          hasInput ||
          (param === BOTTOM_LENGTH_PARAM && summary.indexOf('bottom length') !== -1);
        if (!match) return;
        seen.add(el);
        out.push(el);
      });
    return out;
  }

  function categoryValueLabel(input) {
    if (!input) return '';
    var lab = null;
    if (input.id) {
      try {
        lab = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      } catch (e) {
        lab = document.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]');
      }
    }
    if (!lab) lab = input.closest('label') || input.parentElement;
    return lab ? lab.textContent || '' : '';
  }

  function categoryInputs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('input[name="' + CATEGORY_PARAM + '"]')
    );
  }

  function categoryAllowsBottomLength() {
    var checked = categoryInputs().filter(function (input) {
      return input.checked;
    });

    if (checked.length) {
      for (var i = 0; i < checked.length; i++) {
        if (labelAllowsBottomLength(categoryValueLabel(checked[i]))) return true;
      }
      return false;
    }

    // After Dawn AJAX, checkboxes can lag behind the URL — resolve labels from
    // URL taxonomy values against the (possibly unchecked) option list.
    var urlValues = new URLSearchParams(window.location.search).getAll(CATEGORY_PARAM);
    if (!urlValues.length) return false;

    var byValue = {};
    categoryInputs().forEach(function (input) {
      byValue[String(input.value)] = categoryValueLabel(input);
    });

    for (var j = 0; j < urlValues.length; j++) {
      var label = byValue[String(urlValues[j])];
      if (labelAllowsBottomLength(label)) return true;
      // Taxonomy handle fallback when labels are not in the DOM yet.
      var code = String(urlValues[j]).toLowerCase();
      if (
        code === 'aa-1-4' || // Dresses
        code === 'aa-1-15' || // Skirts
        code === 'aa-1-12-11' || // Trousers
        code === 'aa-1-25-1' // Baby & Children's Bottoms
      ) {
        return true;
      }
    }
    return false;
  }

  function setFilterVisible(el, visible) {
    if (!el) return;
    ensureStyle();
    if (visible) {
      el.classList.remove(HIDDEN_CLASS);
      el.hidden = false;
      el.removeAttribute('aria-hidden');
      el.style.removeProperty('display');
    } else {
      el.classList.add(HIDDEN_CLASS);
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
      if (el.open) el.open = false;
    }
  }

  function urlHasBottomLength() {
    return new URLSearchParams(window.location.search).has(BOTTOM_LENGTH_PARAM);
  }

  function clearBottomLengthFromUrl() {
    if (!urlHasBottomLength()) return false;
    var url = new URL(window.location.href);
    var cleaned = new URLSearchParams();
    url.searchParams.forEach(function (value, key) {
      if (key === BOTTOM_LENGTH_PARAM) return;
      cleaned.append(key, value);
    });
    var qs = cleaned.toString();
    var next = url.pathname + (qs ? '?' + qs : '') + url.hash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next === current) return false;
    window.location.assign(next);
    return true;
  }

  function applyConditionalFacets() {
    ensureStyle();
    var bottomEls = filterDetailsByParam(BOTTOM_LENGTH_PARAM);
    if (!bottomEls.length) return;

    var show = categoryAllowsBottomLength();
    for (var i = 0; i < bottomEls.length; i++) {
      setFilterVisible(bottomEls[i], show);
    }

    if (!show) {
      Array.prototype.slice
        .call(document.querySelectorAll('input[name="' + BOTTOM_LENGTH_PARAM + '"]'))
        .forEach(function (input) {
          if (input.checked) input.checked = false;
        });
      clearBottomLengthFromUrl();
    }
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyConditionalFacets();
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    applyConditionalFacets();
    // Dawn can paint facets after deferred scripts; re-apply a few times.
    setTimeout(applyConditionalFacets, 0);
    setTimeout(applyConditionalFacets, 100);
    setTimeout(applyConditionalFacets, 400);

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.name) return;
        if (t.name.indexOf('filter.') === 0) scheduleApply();
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (t.closest && t.closest('facet-remove, .active-facets__button, .facets__reset')) {
          setTimeout(applyConditionalFacets, 50);
          setTimeout(applyConditionalFacets, 300);
        }
      },
      true
    );

    window.addEventListener('popstate', scheduleApply);

    var roots = [
      document.getElementById('ProductGridContainer'),
      document.querySelector('facet-filters-form'),
      document.querySelector('.facets-container'),
      document.getElementById('main-collection-filters'),
    ].filter(Boolean);

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(scheduleApply);
      roots.forEach(function (root) {
        obs.observe(root, { childList: true, subtree: true });
      });
      obs.observe(document.body, { childList: true, subtree: false });
    }
  });
})();
